import { LoginViewImpl } from './loginview';
import { LoginCSSStyleImpl } from './logincss';
import { UIComponentImpl, UIComponentState, UIDataModel, UIComponentHandler } from '../../../toolkit/uicomponent';
import { BaseContext } from '../../../../utils/basecontext';
import { UIComponentView } from '../../../toolkit/uicomponentview';
import { UIComponentCSSStyle } from '../../../toolkit/uicomponentcss';
import { ChildComponentProps } from '../../mainwrappercomponent';
import { APIFeatures } from '../../../../core/util/apifeatures';
import { LoginAPIModel, LoginAPIModelImpl } from './loginapimodel';
import { APIModelHandler, APIModel } from '../../../toolkit/uicomponentapimodel';
import { RoutingFeatures } from '../../navigation/routingfeature';
import { AlertType } from '../../../toolkit/alert/alerttype';
import { Strings } from 'src/com/sixdee/crbtportal/utils/resources/strings';
import { AESEncryptionDecryption } from 'src/com/sixdee/crbtportal/utils/aseencryption';
import { PasswordValidationCCDtoImpl } from 'src/com/sixdee/crbtportal/core/dto/passwordvalidationcc/passwordvalidationccdto';
export interface LoginComponentProps extends ChildComponentProps
{

}

export interface LoginComponentHandler extends UIComponentHandler
{
    onSignUpClick(): void;
    onForgotpassword(): void;
    onLoginButtonClick(): void;
    onLogoClicked(): void;
}
export interface LoginComponentState extends UIComponentState
{
    
    apiCount: number;

}

export class LoginComponent extends UIComponentImpl<LoginComponentProps, LoginComponentState, UIDataModel> 
implements LoginComponentHandler
{
     private decrementValue:number;
    
     private count:number;
    constructor(props: LoginComponentProps)
    {
        super(props);
        this.state = {apiCount: 1};
  
        this.decrementValue=1;
        this.count = this.state.apiCount;
    }
   
    componentWillUnmount()
    {
        // document.removeEventListener("keydown",()=>'');
    }

    UNSAFE_componentWillMount()
    {
        super.UNSAFE_componentWillMount();
        if(!this.props.context.getUserContext().getIsLoggedIn())
        {
            history.pushState(null, location.href);
            window.onpopstate = function () {
                history.go(1);
            };
        }
    }
    
    onLogoClicked(): void 
    {
        this.props.routeNextFeature(RoutingFeatures.HOME, false);
        // if(this.getContext().getUserContext().getIsLoggedIn())
        // {
        // }
    }

    componentDidMount()
    {
        console.log("-----referrer: " + document.referrer);
        if(this.props.context.getUserContext().getIsLoggedIn())
       {
           this.props.context.getRedirectionHandler().routeNextFeature(RoutingFeatures.HOME, true);
       }
       else
       {
            // if(window.location.origin === "https://ringtune.mpt.com.mm")
            // {
            //     this.decryptCCPortal();

            // }
            this.decryptCCPortal();
            
       }
    }

    protected createComponentView(applicationContext: BaseContext, uiComponentHandler: UIComponentHandler): UIComponentView<UIDataModel>
    {
        return new LoginViewImpl(applicationContext, uiComponentHandler);
    }

    protected createComponentCSS(applicationContext: BaseContext): UIComponentCSSStyle
    {
        return new LoginCSSStyleImpl(applicationContext);
    }
    
    protected createAPIModel(applicationContext: BaseContext, apiModelHandler: APIModelHandler): APIModel
    {
         return new LoginAPIModelImpl(applicationContext, apiModelHandler);
    }

    onLoginButtonClick(): void 
    {
        (this.getView() as LoginViewImpl).showLoader();
        
        this.setState({apiCount: this.count - this.decrementValue });
        
            let request = (this.getView() as LoginViewImpl).getData();
            
            // this.props.context.getUserContext().setMsisdn(request.getMsisdn());
            if((this.getView() as LoginViewImpl).isRememberMe())
            {
                this.props.context.getUserContext().setPassword(request.getPassword());
                this.props.context.getUserContext().setIsRememberMe(true);
            }
            else
            {
                this.props.context.getUserContext().setPassword("");
                this.props.context.getUserContext().setIsRememberMe(false);
            }
            
            this.props.context.setUserContext(this.props.context.getUserContext());

            this.getAPIModel().doLogin(request);
    }
    
    onSignUpClick(): void 
    {
        this.props.routeNextFeature(RoutingFeatures.CREATE_ACCOUNT, false);
    }

    onForgotpassword(): void 
    {
        this.props.routeNextFeature(RoutingFeatures.FORGOT_PASSWORD, false);
    }   
    
    onSuccess(feature: APIFeatures, description: string, data: any): void 
    {
        if(this.state.apiCount === 0)
        {
        (this.getView() as LoginViewImpl).dismissLoader();
        }

        if(feature === APIFeatures.PASSWORD_VALIDATION || 
            feature === APIFeatures.PASSWORD_VALIDATION_CC)
        {
            if(this.props.context.getRedirectionHandler().isRedirectionRequired())
            {
                this.props.context.getRedirectionHandler().redirect();
            }
            else
            {
                this.props.routeNextFeature(RoutingFeatures.HOME, false);
            }
        }
    }

    onFailure(feature: APIFeatures, description: string, data: any): void 
    {
         
        if(this.state.apiCount === 0)
        {
            (this.getView() as LoginViewImpl).dismissLoader();
        }

        if(feature === APIFeatures.PASSWORD_VALIDATION_CC)
        {
            this.props.routeNextFeature(RoutingFeatures.FORBIDDEN, false);
        }
        else
        {
            (this.getView() as LoginViewImpl).showPopup(description,  AlertType.ERROR,
                this.getContext().getResources().getString(Strings.ok)
           ); 
        }
    }
    getAPIModel(): LoginAPIModel {
        return super.getAPIModel() as LoginAPIModel;
    }

    decryptCCPortal()
    {
        let params = String(new URLSearchParams(window.location.search).get("data"));
        let paramResult = (window.location.href).split("?");
        
        console.log("---params: - " + paramResult[1]);
        // console.log("----url search ",paramResult[1].split("="));
      
        if(params !== "null" && params !== null && params !== undefined &&
        document.referrer !== "" && document.referrer !== null && document.referrer !== undefined)
        {
            let decryptedData = AESEncryptionDecryption.decryptWithAESSha1(params.replace(/ /g,"+"), "5en6G6MezRroT3XKqkdPOg==");
            console.log("---params2: - " + params);
            let queryParameters = new URLSearchParams(decryptedData);
            let msisdn = queryParameters.get("msisdn");    
            let channel = queryParameters.get("channel");
            let username = queryParameters.get("userName");
            let password = queryParameters.get("password");

            console.log("decrypteddata: " + decryptedData);
            if(msisdn !== null && msisdn !== undefined && channel !== null && channel !== undefined &&
                username !== null && username !== undefined && password !== null && password !== undefined)
            {
                (this.getView() as LoginViewImpl).showLoader();
                this.setState({apiCount: this.count - this.decrementValue });

                let passwordValidationDto = new PasswordValidationCCDtoImpl();
                passwordValidationDto.setMsisdn(msisdn);
                passwordValidationDto.setPassword(password);
                passwordValidationDto.setUsername(username);
                passwordValidationDto.setchannel(channel);

                passwordValidationDto.setLanguage(this.getContext().getUserContext().getLanguage());
                // (this.getAPIModel() as LoginAPIModel).loginCCRedirection(passwordValidationDto);
                (this.getAPIModel() as LoginAPIModel).getSecurityTokenCCRedirection(passwordValidationDto);
                //force logout
            }
            else
            {
                this.props.routeNextFeature(RoutingFeatures.FORBIDDEN, false);
            }
        }
        // else
        // {
        //     this.props.routeNextFeature(RoutingFeatures.FORBIDDEN, false);
        // }
    }
}


// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/ui/components/login/login/logincomponent.tsx